import React, { useState } from 'react';
import BorderedButton from '../BorderedButton';
import { BeneficiaryAgeProps } from './BeneficiaryAdultValues';
import BeneficiaryChildrenValues from './BeneficiaryChildrenValues';

const minWidth = 256;

const BeneficiaryChildren: React.FC<BeneficiaryAgeProps> = ({
  beneficiary,
  setBeneficiaries
}) => {
  const [open, setOpen] = useState<boolean>(
    beneficiary?.categories.findIndex(x => x.name === 'Children') !== -1 ||
      beneficiary?.categories.findIndex(
        x => x.name === 'Children and youth'
      ) !== -1 ||
      beneficiary?.categories.findIndex(x => x.name === 'Adolescents') !== -1
  );
  const handleOpen = () => setOpen(true);
  if (!open)
    return (
      <BorderedButton
        minWidth={minWidth}
        text="Children &amp; youth"
        onClick={handleOpen}
      />
    );
  return (
    <BeneficiaryChildrenValues
      beneficiary={beneficiary}
      setBeneficiaries={setBeneficiaries}
    />
  );
};

export default BeneficiaryChildren;
